module.exports = __webpack_public_path__ + "media/sfx_chat_4.c0df5ba4.mp3";